/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCloudflareBrowserOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.625 5.375a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05m1.675 0a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05m1.675 0a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 2.975H2l-.5.5v9.975l.5.5h12l.5-.5V3.475zm-.5 1V5.7h-11V3.975zm-11 8.975V6.7h11v6.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.9 9.15.1-.05-.375-.65-1.275.8.025-1.525h-.75L7.65 9.25l-1.275-.8L6 9.1l1.325.725L6 10.55l.375.65 1.275-.8-.025 1.5h.75l-.025-1.5 1.275.8.375-.65-1.325-.725z"
}));

export default SvgCloudflareBrowserOutline;